// extracted by mini-css-extract-plugin
export default {"tabButton":"tab-button__tabButton___2wyDT","selected":"tab-button__selected___1bDPS"};